/* eslint-disable */

export const switchStatusConstants = {
    SWITCH_STATUS_REQUEST: 'SWITCH_STATUS_REQUEST',
    SWITCH_STATUS_SUCCESS: 'SWITCH_STATUS_SUCCESS',
    SWITCH_STATUS_FAILURE: 'SWITCH_STATUS_FAILURE',
};
